<template>
  <section>
    <!-- Componentes externos -->
    <AbrobarObservarListaFicha />
    <SeguimientoListaFicha />
    <Reporte />
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Lista de vacaciones programadas
      rrhh
    </h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <!-- <template slot="buttons">
            <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearActualizarVListaficha({})"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar V listaficha</span>
           </v-tooltip>
          </template> -->

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->

            <td class="text-xs-center">{{ items.item.nombres }}</td>
            <td class="text-xs-center">{{ items.item.fecha_solicitud }}</td>
            <td class="text-xs-center">{{ items.item.fecha_desde }}</td>
            <td class="text-xs-center">{{ items.item.fecha_hasta }}</td>
            <td class="text-xs-center">
              {{ items.item.dias_vaca_programada }}
            </td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td class="text-xs-center">{{ items.item.nro_id }}</td>
            <td class="nowrap text-xs-center">
              <!-- <v-btn 
              slot="activator"
              depressed
              color="primary"
              @click="reporte(items.item.id_persona)"
             > Ver Ficha Personal 
             </v-btn> -->
              <!-- v-if="items.item.estado_ficha!='Revisado' && items.item.estado_ficha!='Creado'" -->
              <v-btn
                v-if="items.item.id_estado_ficha != 39"
                dark
                color="success"
                @click.native="AbrobarObservarListaFicha(items.item)"
              >
                Aprobar/Rechazar
              </v-btn>

              <!-- <v-btn
                v-if="items.item.id_estado_ficha != 39"
                title="Ver seguimiento"
                icon
                color="info"
                @click.native="SeguimientoListaFicha(items.item)"
              >
              <v-icon>remove_red_eye</v-icon>
               
              </v-btn>   -->
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import AbrobarObservarListaFicha from "./dialogs/AbrobarObservarListaFicha"; // Componente de creación y actualización
import SeguimientoListaFicha from "./dialogs/SeguimientoListaFicha";
import Reporte from "./dialogs/Reporte";
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    return {
      url: "vVacasAprobFechas",
      graphql: true,
      estado_vacaciones: [],
      nombres: null,
      fecha_solictud: null,
      // Cabecera de la tabla
      headers: [
        { text: "Nombres", value: "nombres", align: "center" },
        { text: "Fecha solicitud", value: "fecha_solicitud", align: "center" },
        { text: "Fecha salida", value: "fecha_desde", align: "center" },
        { text: "Fecha hasta", value: "fecha_hasta", align: "center" },
        {
          text: "Dias programado",
          value: "dias_vaca_programada",
          align: "center"
        },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Numero", value: "nro_id", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        
                  nombres
                  fecha_solicitud
                  fecha_desde
                  fecha_hasta
                  dias_vaca_programada
                  estado
                  nro_id

      `
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      // filters: [
      //   {
      //     field: "nombres",
      //     label: "Nombres",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String", // Tipo definido en Graphql
      //   },
      //   {
      //     field: "fecha_solicitud",
      //     label: "Fecha solicitud",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String", // Tipo definido en Graphql
      //   },
      //   {
      //     field: "fecha_desde",
      //     label: "Fecha desde",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String", // Tipo definido en Graphql
      //   },
      //   {
      //     field: "fecha_hasta",
      //     label: "Fecha hasta",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String", // Tipo definido en Graphql
      //   },
      //   {
      //     field: "dias_vaca_programada",
      //     label: "Dias programada",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String", // Tipo definido en Graphql
      //   },
      //   {
      //     field: "estado",
      //     label: "Estado",
      //     type: "text", // Tipo de input en el filtro
      //     typeG: "String", // Tipo definido en Graphql
      //   },

      // ],
      // initData: [
      //   {
      //     state: true,
      //     param: "id_jefe",
      //     value: this.getPersonaId(),
      //   },
      // ],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    this.verEstadoVacacion();
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
  },
  // Métodos y funciones del componente
  methods: {
    AbrobarObservarListaFicha(item) {
      this.$bus.$emit("openDialogAbrobarObservarListaFicha", item);
    },
    SeguimientoListaFicha(item) {
      this.$bus.$emit("openDialogSeguimientoListaFicha", item);
    },
    reporte(id_persona) {
      let url = process.env.REPORTE_URL + id_persona;
      this.$bus.$emit("openDialogReporte", url);
    },
    enviarCronograma(item) {
      this.$bus.$emit("openDialogEnviarCronograma", item);
    },
    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      try {
        let res = await this.$service.graphql({
          query: `
						
						query{
                  vVacasPendientesPorJefes(id_jefe: ${id_persona}){
                    rows{
                      id
                      id_jefe
                      id_persona
                      nombres
                      fecha_solicitud
                      fecha_desde
                      fecha_hasta
                      dias_vaca_programada
                      estado
                      nivel
                      nro_id
                    }
                  }
                } 
					`
        });

        this.estado_vacaciones = res.vVacasPendientesPorJefes.rows;

        this.nombres = this.estado_vacaciones[0].nombres;
        this.fecha_solictud = this.estado_vacaciones[0].fecha_solicitud;
      } catch (error) {
        console.log(error);
      }
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      let id_persona = user.id_persona;
      const roles = user.roles;

      return id_persona;
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    AbrobarObservarListaFicha,
    SeguimientoListaFicha,
    Reporte
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones_aprobar/VacacionesAprobarRrhh.vue